import { useCallback, useRef, useState } from 'react'

export const useTopDockHeight = () => {
  const [height, setHeight] = useState(0)
  const observerRef = useRef<ResizeObserver | null>(null)

  const topDockRef = useCallback((node: HTMLDivElement | null) => {
    if (observerRef.current) {
      observerRef.current.disconnect()
      observerRef.current = null
    }
    if (!node) return
    const observer = new ResizeObserver(() => {
      setHeight(node.clientHeight)
    })
    observer.observe(node)
    setHeight(node.clientHeight)
    observerRef.current = observer
  }, [])

  return { height, topDockRef }
}
